import { InputFileForm, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { TWhatsappTemplateForm } from "./whatsappTemplateSchema";
import { GlobalAxios } from "../../../axios/axios-config";
import { ISelectAutomationRuleInputFileProps } from "./models";

const TICKET_AUTOMATION_TEMPLATE_HEADER_FILE_TYPE = {
  IMAGE: "2",
  DOCUMENT: "4",
} as const;

const mediaFileConfigByHeaderFileType = {
  [TICKET_AUTOMATION_TEMPLATE_HEADER_FILE_TYPE.IMAGE]: {
    accept: ".jpg, .jpeg, .png",
    maxFileSize: 5,
  },
  [TICKET_AUTOMATION_TEMPLATE_HEADER_FILE_TYPE.DOCUMENT]: {
    accept: ".txt, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx",
    maxFileSize: 100,
  },
};

const FILE_ROUTE = process.env.REACT_APP_FILEMANAGER + "/api/v1/Upload";

const translationPath = "page.register.extensions.";

export const SelectAutomationRuleInputFile = ({
  onDeleteFile,
}: ISelectAutomationRuleInputFileProps) => {
  const { t } = useTranslation();

  const { control } = useFormContext<TWhatsappTemplateForm>();

  const headerType = useWatch({
    name: "headerType",
    control,
  }) as NonNullable<TWhatsappTemplateForm["headerType"]>;

  const mediaFileConfig =
    mediaFileConfigByHeaderFileType[
      headerType.code as keyof typeof mediaFileConfigByHeaderFileType
    ];

  if (!mediaFileConfig) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <InputFileForm
        name="mediaFile"
        axios={GlobalAxios}
        fileRoute={FILE_ROUTE}
        fileInputProps={{
          accept: mediaFileConfig.accept,
          label: t(translationPath + "file"),
          maxFileSize: mediaFileConfig.maxFileSize,
          mediaTypeCode: "1",
          mediaTypeIdentifier: "TicketAutomationTemplateMediaType",
          parentName: "TicketAutomationTemplateMeta",
          type: "Public",
          onFileSelected: onDeleteFile,
          inputProps: {
            size: "small",
          },
        }}
      />
    </Grid>
  );
};
